
import { ChannelType } from '../types';

export const invoiceData = [
  {
    id: '1',
    number: 'RE-01253',
    date: '19.12.2025',
    customer: 'Geberit AG',
    title: 'Product Delivery Batch 4',
    dueBy: '17.01.2026',
    net: 1150.00,
    gross: 1243.15,
    channel: ChannelType.EMAIL,
    status: 'completed',
    assignedTo: 'u1'
  },
  {
    id: '2',
    number: 'RE-01252',
    date: '19.12.2025',
    customer: 'Sika Schweiz AG',
    title: 'Standard Maintenance Fee',
    dueBy: '17.01.2026',
    net: 1240.00,
    gross: 1340.45,
    channel: ChannelType.PRINT,
    status: 'completed',
    assignedTo: 'u2'
  },
  {
    id: '3',
    number: 'RE-01251',
    date: '19.12.2025',
    customer: 'Lonza AG',
    title: 'Laboratory Service Agreement',
    dueBy: '17.01.2026',
    net: 4500.00,
    gross: 4864.50,
    channel: ChannelType.EDI,
    status: 'sendable',
    assignedTo: 'u1'
  },
  {
    id: '4',
    number: 'RE-01250',
    date: '18.12.2025',
    customer: 'Givaudan SA',
    title: 'Flavor Development Project',
    dueBy: '16.01.2026',
    net: 890.00,
    gross: 962.10,
    channel: ChannelType.EBILL,
    status: 'sendable',
    assignedTo: 'u4'
  },
  {
    id: '5',
    number: 'RE-01248',
    date: '18.12.2025',
    customer: 'Swatch Group AG',
    title: 'Retail Integration Support',
    dueBy: '16.01.2026',
    net: 2400.00,
    gross: 2594.40,
    channel: ChannelType.EBILL,
    status: 'failed',
    failDate: '19.12.2025, 12:53:52',
    assignedTo: 'u2'
  },
  {
    id: '6',
    number: 'RE-01247',
    date: '17.12.2025',
    customer: 'Richemont International SA',
    title: 'Audit Compliance Q4',
    dueBy: '15.01.2026',
    net: 5929.00,
    gross: 6409.25,
    channel: ChannelType.EBILL,
    status: 'failed',
    failDate: '17.12.2025, 20:59:49',
    assignedTo: 'u1'
  },
  {
    id: '7',
    number: 'RE-01246',
    date: '16.12.2025',
    customer: 'ABB Schweiz AG',
    title: 'Grid Management Services',
    dueBy: '14.01.2026',
    net: 12500.00,
    gross: 13512.50,
    channel: ChannelType.EDI,
    status: 'completed',
    assignedTo: 'u4'
  },
  {
    id: '13',
    number: 'RE-01249',
    date: '18.12.2025',
    customer: 'Holcim (Schweiz) AG',
    title: 'Raw Material Fulfillment',
    dueBy: '16.01.2026',
    net: 3100.00,
    gross: 3351.10,
    channel: ChannelType.EMAIL,
    status: 'rejected',
    assignedTo: 'u2'
  },
  {
    id: '8',
    number: 'RE-01245',
    date: '15.12.2025',
    customer: 'Lindt & Sprüngli AG',
    title: 'Supply Chain Consulting',
    dueBy: '13.01.2026',
    net: 450.00,
    gross: 486.45,
    channel: ChannelType.EMAIL,
    status: 'sendable',
    assignedTo: 'u1'
  },
  {
    id: '9',
    number: 'RE-01244',
    date: '14.12.2025',
    customer: 'Schindler Aufzüge AG',
    title: 'Maintenance Contract Jan',
    dueBy: '12.01.2026',
    net: 3200.40,
    gross: 3459.65,
    channel: ChannelType.PRINT,
    status: 'sendable',
    assignedTo: 'u3'
  },
  {
    id: '10',
    number: 'RE-01243',
    date: '13.12.2025',
    customer: 'UBS Group AG',
    title: 'Platform Subscription 2026',
    dueBy: '11.01.2026',
    net: 120.50,
    gross: 130.25,
    channel: ChannelType.EBILL,
    status: 'completed',
    assignedTo: 'u4'
  },
  {
    id: '11',
    number: 'RE-01242',
    date: '12.12.2025',
    customer: 'SGS SA',
    title: 'Certification Services',
    dueBy: '10.01.2026',
    net: 18500.00,
    gross: 19998.50,
    channel: ChannelType.EDI,
    status: 'sendable',
    assignedTo: 'u1'
  },
  {
    id: '12',
    number: 'RE-01241',
    date: '11.12.2025',
    customer: 'Sonova AG',
    title: 'Digital Interface Support',
    dueBy: '09.01.2026',
    net: 640.00,
    gross: 691.85,
    channel: ChannelType.EMAIL,
    status: 'completed',
    assignedTo: 'u2'
  }
];
